import React, { useEffect, useState } from "react";
import "./appReview.scss";
import timer from "../../Assets/svg/timer.svg";
import desIcon from "../../Assets/svg/desclaimer.svg";

import CustomizedAccordions from "../modules/Accordian";
import reupload from "../../Assets/svg/upload red.svg";
import cross from "../../Assets/svg/cross-grey-icon.svg";
import redwarning from "../../Assets/svg/desclaimer red.svg";
import pdf from "../../Assets/svg/pdf-logo.svg";
import { useSelector, useDispatch } from "react-redux";
import { api } from "../../Services";
import { addTokenInfo, doLogout } from "../LoginPage/redux/actions";
import verified from "../../Assets/svg/verified.svg";
import Reupload from "./Reupload";
import DocUpload from "../modules/DocUpload";
import Button from "../modules/Button";
import ModalComponent from "../modules/Modal";
import GradientLoader from "../modules/Loader";
import PDFViewer from "../modules/PDFViewer";
import { GetLogout } from "../modules/Logout";
import { resetState } from "../PersonalInfo/redux/actions";
import { resetIncome } from "../IncomeDetails/redux/actions";
import { resetEdu } from "../Education/redux/actions";
import { resetRegister } from "../Register/redux/actions";
import { resetApp } from "../ApplicationForm/redux/actions";
import { resetQueries } from "../Queries/redux/actions";
import { resetStatus } from "../WelcomeBack/redux/actions";
import { clearDisburse } from "../DisburseForm/redux/actions";
import { resetClear } from "../Connect/redux/actions";

function VerificationTab() {
  const dispatch = useDispatch();
  const [doc, setDoc] = useState(null);
  const personalInfo = useSelector((state) => state.personal.personalInfo);

  const [isLoader, showLoader] = useState(false);
  const [edit, setEdit] = useState({});
  const [viewListData, setviewListData] = useState({});
  const [view, setView] = useState({
    view1: false,
    view2: false,
    view3: false,
  });
  const [uploading, setLoading] = useState(false);
  const [isModal, showModal] = useState(false);
  const [newDoc, setNewDoc] = useState({
    admissionLetter: null,
    paymentReciept: null,
  });
  const [err1, showErr1] = useState(false);
  const [err2, showErr2] = useState(false);
  const [docData, setDocData] = useState("");

  const tokenData = useSelector((state) => state.tokens.tokens);
  const openInTab = (url) => {
    window.open(url);
  };

  const getLogout = async () => {
    // const personalInfo = useSelector((state) => state.personal.personalInfo);
    // const dispatch = useDispatch();
    // const tokenData = useSelector((state) => state.tokens.tokens);

    try {
      let users = await api.logout(tokenData.token, personalInfo?.mobile);
      console.log('logout api', users)
      // if (users.statusCode == 200) {
        dispatch(resetState());
        dispatch(resetIncome());
        dispatch(resetEdu());
        dispatch(resetRegister());
        dispatch(resetApp());
        dispatch(resetQueries());
        dispatch(resetStatus());
        dispatch(clearDisburse());
        dispatch(resetClear());
        dispatch(doLogout());
      // }
      // return users;
    } catch (error) {
      console.error("Error logging out:", error);

      //   } finally {
      // setIsLoading(false);
    }
  };

  const logoutMsg = async () => {
    let users = await getLogout();
    console.log("logout api", users);
    console.log("u have been logged out");
  };
  const callDocsApi = async () => {
    try {
      const callDoc = await api.getDocuments(
        "application",
        tokenData.applicationData.id,
        tokenData.token
      );
      console.log("callDoc", callDoc);
      if (
        callDoc.statusCode !== 200 &&
        callDoc.data.includes("Session expired")
      ) {
        logoutMsg();
      }
      return callDoc;
    } catch (error) {
      console.error("Error uploading Document:", error);
      if (error?.statusCode !== 200 && error?.data?.includes("Session expired")) {
        logoutMsg();
      }
      // Handle error scenario
    }
  };

  const getPDF = async (doc) => {
    // showModal(true)

    try {
      const docs1 = await api.getPDFData(tokenData.token, doc.id);
      if (docs1.statusCode !== 200 && docs1.data.includes("Session expired")) {
        logoutMsg();
      }
      return docs1;
    } catch (err) {
      if (err?.statusCode !== 200 && err?.data?.includes("Session expired")) {
        logoutMsg();
      }
      // setLoading(false);
      // alert("Sorry! Something went wrong, Please try again.");
      // setErr({ showErr: true, errText: err.message });
    }
  };
  const viewPDF = async (doc) => {
    // setLoading(true);

    try {
      const docs1 = await getPDF(doc);
      console.log("base 64", docs1);
      // if (docs1.statusCode == 200) {
      // setLoading(false);
      setDocData(docs1.data.resource_data[0]);
      showModal(true);
      // } else {
      //   setLoading(false);
      // }
    } catch (err) {
      // setLoading(false);
      console.log("err", err);

      // alert("Sorry! Something went wrong, Please try again.");
      // setErr({ showErr: true, errText: err.message });
    }
  };

  const getDocs = async () => {
    const docs2 = await callDocsApi();
    dispatch(addTokenInfo(["docs", docs2?.data]));
  };

  
  const handleUpload = async (type) => {
    //const fileInput = document.getElementById(`${type}-upload`);
    //if (fileInput) {
    //const file = fileInput.files[0];
    console.log(JSON.stringify(tokenData?.docs));
    console.log(type);
    let file;
    if (type === "admissionLetter") {
      file = newDoc?.admissionLetter;
    }
    if (type === "paymentReciept") {
      file = newDoc?.paymentReciept;
    }
    console.log(file);
    if (file) {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("name", file?.name);
      formData.append("size", file?.size);
      formData.append("documentType", type);
      formData.append("fileType", file?.type.split("/")[1]);
      const result = await api.uploadDocument(
        "application",
        tokenData?.applicationData?.id,
        tokenData?.token,
        formData
      );
      console.log("result", result);
      const docs1 = await getDocs();
      if (docs1?.statusCode == 200) {
        dispatch(addTokenInfo(["docs", docs1?.data]));
        if (type === "admissionLetter") {
          setNewDoc({ admissionLetter: null });
        }
        if (type === "paymentReciept") {
          setNewDoc({ paymentReciept: null });
        }
      }
      if (
        result.statusCode !== 200 &&
        result.data.includes("Session expired")
      ) {
        logoutMsg();
      }
      // if (type === "admissionLetter") {

      //   setUploading1(false);
      // } else {

      //   setUploading1(false);
      // }
    }
  };

  const addData = (type, value) => {
    const allowedTypes = [
      "application/pdf",
      "image/jpeg",
      "image/png",
      "application/msword",
    ];
    let isFormat = false;

    if (value) {
      if (value !== null && value?.size / 1024 / 1024 > 2) {
        value = null;
        // if (type === "admissionLetter") {
        //   showErr1(true);
        //   // setTimeout(() => showErr1(false), 3000);
        // } else {
        //   showErr2(true);
        //   // setTimeout(() => showErr2(false), 3000);
        // }
      } else {
        for (let i in allowedTypes) {
          if (value?.type === allowedTypes[i]) {
            isFormat = true;
          }
        }
      }
      if (type === "admissionLetter") {
        if (!isFormat) {
          alert("Only PDF, JPEG, PNG, and Word files are allowed.");
          // setDoc(null); // Clear the file input
          // setNewDoc({:null})
          setNewDoc({ admissionLetter: null });

          // setAddmissionLetter(null);
        } else {
          setNewDoc({ admissionLetter: value });

          // setNewDoc({admissionLetter:value})

          // setAddmissionLetter(value);
        }
      } else {
        if (!isFormat) {
          alert("Only PDF, JPEG, PNG, and Word files are allowed.");
          // setDoc(null); // Clear the file input
          // setPaymentReciept(null);
        } else {
          // setPaymentReciept(value);
        }
        // setPaymentReciept(value);
      }
    }

    //dispatch(addEduInfo({ type: type, value: value }));
  };
  const getVerifiedStatus = (item) => {
    let verifiedContent = "";
    if (
      tokenData.applicationStatus === "Waitlisted" ||
      tokenData.applicationStatus === "Awarded"
    ) {
      verifiedContent =
        item?.status === "Rejected" ? (
          <>
            <img src={redwarning} alt="tick" />
            <span>Incorrect</span>
          </>
        ) : item?.status === "Reupload" ? (
          <>
            <img src={reupload} alt="tick" />
            <span>Reupload</span>
          </>
        ) : item?.status === "Verified" ? (
          <>
            <img src={verified} alt="tick" />
            <span style={{ color: "#287A5B" }}>Verified</span>
          </>
        ) : item?.status === "Reassign to Ops Team" ? (
          <>
            <img src={timer} alt="tick" />
            <span>Verification in-Progress</span>
          </>
        ) : item?.status === "Ops Team In progress" ? (
          <>
            <img src={timer} alt="tick" />
            <span>Verification in-Progress</span>
          </>
        ) : item?.status ===
          "Regional Language Document Verification in-Progress" ? (
          <>
            <img src={timer} alt="tick" />
            <span>Verification in-Progress</span>
          </>
        ) : item?.status === "Candidate Reuploaded Deocument" ? (
          <>
            <img src={timer} alt="tick" />
            <span>Verification in-Progress</span>
          </>
        ) : item?.status === "Submitted" ? (
          <>
            <img src={timer} alt="tick" />
            <span>Verification in-Progress</span>
          </>
        ) : item?.status ? (
          <>
            <img src={timer} alt="tick" />
            <span>Verification in-Progress</span>
          </>
        ) : (
          <>
            <img src={timer} alt="tick" />
            <span>Verification in-Progress</span>
          </>
        );
    } else {
      verifiedContent =
        item?.status === "Reupload" ? (
          <>
            <img src={reupload} alt="tick" />
            <span>Reupload</span>
          </>
        ) : (
          <>
            <img src={timer} alt="tick" />
            <span>Verification in-Progress</span>
          </>
        );
    }
    return verifiedContent;
  };
  const getDocItem = (title, content) => {
    const docItem = (
      <div className="item-review">
        <div className="md-desc member-title">
          {title === "Income Certificate" ? "My Income Certificate" : title}
        </div>
        <div className="md-desc doc">{content?.name}</div>
        <div className="md-desc doc-phase">{getVerifiedStatus(content)}</div>

        <div
          onClick={() => viewPDF(content)}
          // onClick={() => window.open(content?.documentUrl)}
          className={`md-desc view-btn ${
            content?.status === "Reupload" && "reupload-view"
          }`}
        >
          View
        </div>
      </div>
    );
    return docItem;
  };
  useEffect(() => {
    let viewList = {};
    for (let i in tokenData?.docs) {
      if (tokenData?.docs[i]?.type === "Income Certificate") {
        viewList[
          `${tokenData?.docs[i].documentType.split("Income")[0]}View`
        ] = false;
      }
    }
    setviewListData({ ...viewList });
    getDocs();
  }, []);
  console.log("tokenData?.docs", tokenData?.docs);
  return (
    <div className="verify-review">
      <div className="review-div">
        <div className="set-title">Income Details</div>
        <div className="docs-list">
          {tokenData?.docs &&
            Object.keys(tokenData?.docs)?.map((item, index) => {
              if (tokenData?.docs[item]?.type?.includes("Income Certificate")) {
                return (
                  <div key={index} className="doc-list-item">
                    {getDocItem(
                      tokenData?.docs[item]?.type,
                      tokenData?.docs[item]
                    )}

                    {tokenData?.docs[item]?.status === "Reupload" && (
                      <CustomizedAccordions reupload={true}>
                        <Reupload doc={tokenData?.docs[item]} />
                      </CustomizedAccordions>
                    )}
                  </div>
                );
              }
            })}
        </div>
      </div>

      <div className="review-div">
        <div className="set-title">Education Details</div>

        <div className="docs-list">
          {tokenData?.docs?.admissionLetter && (
            <div className="doc-list-item">
              {getDocItem("Admission letter", tokenData?.docs?.admissionLetter)}

              {/*  */}
              {tokenData?.docs?.admissionLetter?.status === "Reupload" && (
                <CustomizedAccordions reupload={true}>
                  <Reupload doc={tokenData?.docs?.admissionLetter} />
                </CustomizedAccordions>
              )}
            </div>
          )}
          {tokenData?.docs?.paymentReciept && (
            <div className="doc-list-item">
              {getDocItem("Fee Reciept", tokenData?.docs?.paymentReciept)}

              {tokenData?.docs?.paymentReciept?.status === "Reupload" && (
                <CustomizedAccordions reupload={true}>
                  <Reupload doc={tokenData?.docs?.paymentReciept} />
                </CustomizedAccordions>
              )}
            </div>
          )}
        </div>
      </div>
      <div className="review-div">
        <div className="set-title">Personal Details</div>

        <div className="docs-list">
          {tokenData?.docs?.ProfilePicture && (
            <div className="doc-list-item">
              {getDocItem("Profile Picture", tokenData?.docs?.ProfilePicture)}

              {/*  */}
              {tokenData?.docs?.ProfilePicture?.status === "Reupload" && (
                <CustomizedAccordions reupload={true}>
                  <Reupload doc={tokenData?.docs?.ProfilePicture} />
                </CustomizedAccordions>
              )}
            </div>
          )}
          {tokenData?.docs?.currentAddressProof && (
            <div className="doc-list-item">
              {getDocItem(
                "Current Address Proof",
                tokenData?.docs?.currentAddressProof
              )}

              {tokenData?.docs?.currentAddressProof?.status === "Reupload" && (
                <CustomizedAccordions reupload={true}>
                  <Reupload doc={tokenData?.docs?.currentAddressProof} />
                </CustomizedAccordions>
              )}
            </div>
          )}
          {tokenData?.docs?.BirthCertificate && (
            <div className="doc-list-item">
              {getDocItem(
                "Birth Certificate",
                tokenData?.docs?.BirthCertificate
              )}

              {tokenData?.docs?.BirthCertificate?.status === "Reupload" && (
                <CustomizedAccordions reupload={true}>
                  <Reupload doc={tokenData?.docs?.BirthCertificate} />
                </CustomizedAccordions>
              )}
            </div>
          )}
        </div>
      </div>
      <ModalComponent
        className={"pdf-view-model"}
        show={isModal}
        handleClose={() => showModal(false)}
        // title={""}
        // content={""}
        noCross={false}
        // countDown={ModalData.countDown}
      >
        <PDFViewer docData={docData} />
      </ModalComponent>
      <ModalComponent
        className={"loader-model"}
        show={uploading}
        // handleClose={() => CancelData()}
        // title={ModalData.title}
        // content={ModalData.desc}
      >
        <GradientLoader />
      </ModalComponent>
    </div>
  );
}

export default VerificationTab;
